import React, { useEffect } from 'react'
import { useAuth } from '../context/AuthContext.js'
import { useNotification } from '../context/NotificationContext.js';

function Users() {
  
    const {fetchAllUsers, allUsers, deleteUser, updateUserStatus} = useAuth();
    const {postNotification} = useNotification();

    useEffect(() => {
        fetchAllUsers()
    }, [])

    async function handleDeleteUser(id) {
         await deleteUser(id)
         await fetchAllUsers()
    }

const toggleKYCStatus = async (userId, currentStatus) => {
    try {
        const newStatus = currentStatus === 'true' ? 'false' : 'true';
        const data = {
            status: newStatus
        }
        
        await updateUserStatus(userId, data)
          await fetchAllUsers()

        if (newStatus === 'true') {
            const notifyData ={
            message:  `Your Kyc status has just been approved` ,
            type: 'personal',
            user_id: userId,
            sender_id: userId,
            url: `/dashboard/profile`
            }
            await postNotification(notifyData)
          }

         

       
    } catch (error) {
        console.error('Error updating status:', error);
    }
};


  return (
    <div className="homify-recommendation margin-top2 " id="recommendation">
        <div className="admin-section">
            <h2 className='admin-category'>Users</h2>
            <table className='admin-table'>
                <thead className='thread'>
                    <tr className='tr'>
                        <th className='th'>SN</th>
                        <th className='th'>Name</th>
                        <th className='th'>Phone</th>
                        <th className='th'>Email</th>
                        <th className='th'>KYC Status</th>
                        <th className='th'>Option</th>
                    </tr>
                </thead>
                <tbody className='tbody'>
                    {allUsers.map((user, index) => (
                        <tr className='tr' key={user.id}>
                            <td className='td'>{index + 1}</td>
                            <td className='td'>{user.name}</td>
                            <td className='td'>{user.phone}</td>
                            <td className='td'>{user.email}</td>
                            {/* <td className='td'>{user.kyc_status ? 'Verified' : 'Not Verified'}</td> */}
                            <td className='td'>
                                <label className="switch">
                                <input 
                                    type="checkbox" 
                                    checked={user.status === 'true'} 
                                    onChange={() => toggleKYCStatus(user.id, user.status)} 
                                />
                                <span className="slider"></span>
                                </label>
                            </td>
                            <td className='td'><span onClick={() => handleDeleteUser(user.id)} className='upload-document-red'>Delete</span></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default Users